// extracted by mini-css-extract-plugin
module.exports = {"list":"QuoteList_list__ZVhXG","sorting":"QuoteList_sorting__3dzlH"};